(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-4 
  (:require [frontend.ui.component.lp-portal.page.pdf.view :as page]
            [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
            [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
            [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]))

(defn fund-update-text
  [{:keys [fund-update-1 fund-update-2] :as data}]
  (card/card
   ""
   (column/half-columns
    (text-content/rich-content (->> fund-update-1
                                    :rich-content))
    (text-content/rich-content (->> fund-update-2
                                    :rich-content)))))
(defn view
  [data]
  (page/page
   (page/page-title-with-line {:fund-name  (:fund-name data)
                               :reference-date (:reference-date data)
                               :lower-case-title? true})

   [(fund-update-text data)]))
